export default {
  state: {
    punchoutCategoryList: [] // punchout 分类列表
  },
  mutations: {
    categoryListUpdate (state, punchoutCategoryList) {
      state.punchoutCategoryList = punchoutCategoryList
    }
  },
  actions: {
  }
}
